import React, { useState, useRef, useEffect } from 'react';
import { LogIn, LogOut, User as UserIcon, Package, Heart, Settings } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function AccountMenu() {
  const { user, loading, login, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  if (loading) {
    return <UserIcon size={20} className="opacity-40" />;
  }

  if (!user) {
    return (
      <button onClick={login} className="hidden sm:inline-flex items-center gap-1.5 text-sm font-semibold" aria-label="Sign in">
        <LogIn size={18} />
        <span className="hidden md:inline">Sign in</span>
      </button>
    );
  }

  const initial = (user.name || user.email || '?').trim()[0].toUpperCase();

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen(v => !v)} className="flex items-center gap-2" aria-label="Account menu">
        {user.picture ? (
          <img src={user.picture} alt={user.name} className="w-8 h-8 rounded-full object-cover ring-2 ring-[color:var(--gk-gold)]/60" />
        ) : (
          <div className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold" style={{ background: 'var(--gk-green)', color: 'var(--gk-gold)' }}>{initial}</div>
        )}
      </button>

      {open && (
        <div className="absolute right-0 top-11 w-64 rounded-xl overflow-hidden shadow-2xl z-50" style={{ background: '#fff', border: '1px solid #ecdfc7' }}>
          <div className="px-4 py-3 border-b" style={{ borderColor: '#ecdfc7', background: 'var(--gk-cream)' }}>
            <div className="font-serif text-sm font-bold" style={{ color: 'var(--gk-green-dark)' }}>Namaste, {user.name?.split(' ')[0] || 'friend'}!</div>
            <div className="text-xs truncate" style={{ color: 'var(--gk-muted)' }}>{user.email}</div>
          </div>
          <div className="py-1">
            <a href="/my/orders" className="flex items-center gap-3 px-4 py-2.5 text-sm hover:bg-[color:var(--gk-cream)]" style={{ color: 'var(--gk-ink)' }}>
              <Package size={16} style={{ color: 'var(--gk-green)' }} /> My Orders
            </a>
            <a href="#" className="flex items-center gap-3 px-4 py-2.5 text-sm hover:bg-[color:var(--gk-cream)]" style={{ color: 'var(--gk-ink)' }}>
              <Heart size={16} style={{ color: 'var(--gk-green)' }} /> Wishlist
            </a>
            <a href="#" className="flex items-center gap-3 px-4 py-2.5 text-sm hover:bg-[color:var(--gk-cream)]" style={{ color: 'var(--gk-ink)' }}>
              <Settings size={16} style={{ color: 'var(--gk-green)' }} /> Account Settings
            </a>
            <button onClick={logout} className="w-full flex items-center gap-3 px-4 py-2.5 text-sm border-t hover:bg-[color:var(--gk-cream)]" style={{ color: 'var(--gk-terracotta)', borderColor: '#ecdfc7' }}>
              <LogOut size={16} /> Sign out
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
